// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help_text {
  text-align: center;
  margin: 0px 5px 41px 5px;
  color: #6a6666;
  line-height: 1.5;
  word-break: break-word;
}

.recover_form {
  padding: 0px 60px;
  width: 100%;
  box-sizing: border-box;
}

.recover_input {
  margin-bottom: 25px;
}

.recover_input--error {
  border-color: #ff4d4f !important;
  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15);
}

.recover_error {
  margin: 0 0 12px;
  color: #ff4d4f;
  font-size: 12px;
}

.go_home_block {
  text-align: center;
  margin-top: 10px;
}

@media screen and (max-width: 767px) {
  .recover_form {
    padding: 0px 20px;
  }
  .help_text {
    margin: 0px 0px 28px 0px;
  }
}
@media screen and (max-width: 575px) {
  .recover_form {
    padding: 0px 14px;
  }
  .help_text {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RecoverPassword/RecoverPassword.sass"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AACA;EACI,iBAAA;EACA,WAAA;EACA,sBAAA;AAEJ;;AAAA;EACI,mBAAA;AAGJ;;AADA;EACI,gCAAA;EACA,6CAAA;AAIJ;;AAFA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AAKJ;;AAHA;EACI,kBAAA;EACA,gBAAA;AAMJ;;AAJA;EACI;IACI,iBAAA;EAON;EALE;IACI,wBAAA;EAON;AACF;AANA;EACI;IACI,iBAAA;EAQN;EANE;IACI,eAAA;EAQN;AACF","sourcesContent":[".help_text\n    text-align: center\n    margin: 0px 5px 41px 5px\n    color: #6a6666\n    line-height: 1.5\n    word-break: break-word\n\n.recover_form\n    padding: 0px 60px\n    width: 100%\n    box-sizing: border-box\n\n.recover_input\n    margin-bottom: 25px\n\n.recover_input--error\n    border-color: #ff4d4f !important\n    box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15)\n\n.recover_error\n    margin: 0 0 12px\n    color: #ff4d4f\n    font-size: 12px\n\n.go_home_block\n    text-align: center\n    margin-top: 10px\n\n@media screen and (max-width: 767px)\n    .recover_form\n        padding: 0px 20px\n\n    .help_text\n        margin: 0px 0px 28px 0px\n\n@media screen and (max-width: 575px)\n    .recover_form\n        padding: 0px 14px\n\n    .help_text\n        font-size: 14px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
